import { WatchQueryFetchPolicy, useQuery } from '@apollo/client'

import { GetDashboardStatsDocument } from '@/graphql/purchase-plus/generated/getDashboardStats.generated'
import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

interface UseGetDashboardStatsProps {
  fetchPolicy?: WatchQueryFetchPolicy
}

export function useGetDashboardStats(args?: UseGetDashboardStatsProps) {
  const { fetchPolicy = 'cache-and-network' } = args || {}
  const { currentOrganisation } = useSessionUser()
  const { data, error, loading } = useQuery(GetDashboardStatsDocument, {
    variables: {
      newApprovalWorkflows: !!currentOrganisation?.featureFlags?.newApprovalWorkflows,
      newRequisitionApprovalWorkflows: !!currentOrganisation?.featureFlags?.newRequisitionApprovalWorkflows,
    },
    fetchPolicy,
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return {
    dashboardStats: {
      ...data?.dashboardStats,
      invoicesAwaitingApprovalCount: currentOrganisation?.featureFlags?.newApprovalWorkflows
        ? data?.dashboardStats?.workflowInvoicesAwaitingApprovalCount
        : data?.dashboardStats?.invoicesAwaitingApprovalCount,
      requisitionsAwaitingApprovalCount: currentOrganisation?.featureFlags?.newRequisitionApprovalWorkflows
        ? data?.dashboardStats?.workflowRequisitionsAwaitingApprovalCount
        : data?.dashboardStats?.requisitionsAwaitingApprovalCount,
    },
    error,
    loading,
  }
}
